import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

// project imports
import { useAuth } from "../../../utils/auth";
import { useEffect } from "react";

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const KalendarGuard = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
    if (
      user &&
      !user.roles.some((role) => role.nazov === "kalendar") &&
      !user.roles.some((role) => role.nazov === "admin")
    ) {
      navigate("/app/not-allowed");
    }
  }, [user, navigate]);

  return children;
};

KalendarGuard.propTypes = {
  children: PropTypes.node,
};

export default KalendarGuard;
